module.exports = __webpack_public_path__ + "img/osense-logo.8c02eaa2.png";